module.exports = __webpack_public_path__ + "static/media/Limitless_menu_2024-12-17.792049e3.pdf";